import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProductsService } from '../products.service';
import { ProductCategory } from '../products.model';

@Component({
  selector: 'app-category-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss']
})
export class CategoryModalComponent implements OnInit {
  @Input() categories: ProductCategory[] = [];
  @Input() departmentsId: string = '';
  editingCategory: ProductCategory | null = null;

  categoryForm: FormGroup;
  private fb = inject(FormBuilder);
  private productService = inject(ProductsService);
  private toastr = inject(ToastrService);
  public activeModal = inject(NgbActiveModal);

  constructor() {
    this.categoryForm = this.fb.group({
      name: [''],
      description: ['']
    });
  }

  ngOnInit(): void {}

  editCategory(category: ProductCategory) {
    this.editingCategory = category;
    this.categoryForm.patchValue({
      name: category.name,
      description: category.description,
    });
  }

  saveCategory() {
    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();
      return;
    }
    if (this.editingCategory) {
      this.productService.updateCategory(this.editingCategory.id, this.categoryForm.value).subscribe({
        next: (res: ProductCategory) => {
          const idx = this.categories.findIndex(c => c.id === res.id);
          if (idx > -1) {
            this.categories[idx] = res;
          }
          this.toastr.success('Category updated');
          this.editingCategory = null;
          this.categoryForm.reset();
        },
        error: () => this.toastr.error('Update failed')
      });
    } else {
      let body = {...this.categoryForm.value, departmentsId: this.departmentsId };
      this.productService.addCategory(body).subscribe({
        next: (res: any) => {
          this.toastr.success('Category saved');
          this.activeModal.close(res);
        },
        error: () => this.toastr.error('Save failed')
      });
    }
  }
}
